import { render, staticRenderFns } from "./relatorioResumoGeral.vue?vue&type=template&id=77e12fca&scoped=true&"
import script from "./relatorioResumoGeral.vue?vue&type=script&lang=js&"
export * from "./relatorioResumoGeral.vue?vue&type=script&lang=js&"
import style0 from "./relatorioResumoGeral.vue?vue&type=style&index=0&id=77e12fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e12fca",
  null
  
)

export default component.exports